import React, { useEffect } from "react";
import neighborhoodTimeline from "./chart";
import styles from "./Neighborhood.module.css";
import moment from "moment";
import * as d3 from "d3";

const today = moment().format("MM/DD/YYYY");
const lastYear = moment().format("MM/DD/2020");
const parse_time = d3.timeParse("%m/%d/%Y");

const Neighborhood = ({ data, index }) => {
  // console.log("neighborhood", data);
  const svgKey = data.key.split(" ").join("").split("/").join("-");
  useEffect(() => neighborhoodTimeline(data.values, svgKey));

  const todayTotal = data.values.filter((d) => {
    return d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2021";
  }).length;
  const lastYearTotal = data.values.filter((d) => {
    return (
      d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2020" &&
      parse_time(d.dateofincident) <= parse_time(lastYear)
    );
  }).length;
  let xAxis;
  if (index === 0) {
    xAxis = (
      <div className={styles.XAxis}>
        <span>Jan. 1.</span>
        <span>{d3.timeFormat("%b. %-e")(parse_time(today))}</span>
      </div>
    );
  }
  return (
    <div className={styles.Neighborhood}>
      <p>{data.key.split("/")[0]}</p>
      <p className={styles.Today}>2021: {todayTotal}</p>
      <p className={styles.LastYear}>2020: {lastYearTotal}</p>
      <div id={svgKey}>
        <svg
          className="container"
          viewBox="0 0 500 300"
          preserveAspectRatio="xMinYMin slice"
          width="100%"
          height="100%"
        ></svg>
      </div>
      {xAxis}
    </div>
  );
};

export default Neighborhood;

// useEffect(() =>
//     neighborhoodTimeline(
//       props.neighborhood,
//       props.data,
//       props.timePeriod,
//       props.currentDate
//     )
//   );

//   const total = props.data.filter(
//     (d) =>
//       d.communityarea.toLowerCase() ===
//       props.neighborhood.toLowerCase()
//   ).length;
//   return (
//     <div>
//       <p>{props.neighborhood}</p>
//       <div id={props.neighborhood.split(" ").join("")}>
//         <svg
//           className="container"
//           viewBox="0 0 500 300"
//           preserveAspectRatio="xMinYMin slice"
//           width="100%"
//           height="100%"
//         ></svg>
//       </div>
//     </div>
//   );
